export function scriptLoader (url = '', cb = () => {}) {
  const s = document.createElement('script')
  s.type = 'text/javascript'
  s.src = url
  s.onload = cb
  document.body.appendChild(s)
}
